import { logError } from './ApiHelper';

const getStringValue = (value: any): string => {
  try {
    switch (typeof value) {
      case 'string':
        return value;

      case 'number':
      case 'bigint':
      case 'boolean':
      case 'undefined':
      case 'symbol':
        return String(value);
      case 'object':
        return JSON.stringify(value);
      case 'function':
        // eslint-disable-next-line no-console
        console.error('Function is not supported in local storage');
        return '';
      default:
        return '';
    }
  } catch (ex) {
    logError(ex);
    return '';
  }
};

export const LocalStorage = {
  setItem: (key: string, value: any) => {
    if (!key) return;
    localStorage.setItem(key, getStringValue(value));
  },

  getItem: (key: string) => {
    if (!key) return;
    const value = localStorage.getItem(key);

    if (value) {
      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    }
  },
  deleteItem: (key: string) => {
    if (!key) return;
    localStorage.removeItem(key);
  },
  clearStorage: () => {
    localStorage.clear();
  }
};

// todo depreciate this
export const pushToLocalStorage = (key: string, value: any) => {
  const stringifiedValue = typeof value === 'string' ? value : JSON.stringify(value);
  localStorage.setItem(key, stringifiedValue);
};

export const pushToSessionStorage = (key: string, value: any) => {
  const stringifiedValue = typeof value === 'string' ? value : JSON.stringify(value);
  sessionStorage.setItem(key, stringifiedValue);
};

export const removeLocalStorageByKey = (key: string) => {
  localStorage.removeItem(key);
};

export const removeSessionStorageByKey = (key: string) => {
  sessionStorage.removeItem(key);
};

export const getFromSessionStorage = (key: string) => {
  if (!key) return;
  const value = sessionStorage.getItem(key);

  if (value) {
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }
};
